<template>
  <CasinoOverview />
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'casino-page',
})

useSeoData('casino-category')
</script>
